import * as Device from "expo-device";
import { Platform } from "react-native";

import { getAppVersionLabel } from "@/lib/appVersion";

export type ParentDeviceInfo = {
    type: string;
    os_version?: string;
    app_version?: string;
    device_name?: string;
};

/** Structured device metadata sent with S4P authentication requests. */
export function getParentDeviceInfo(): ParentDeviceInfo {
    const info: ParentDeviceInfo = {
        type: Platform.OS,
        app_version: getAppVersionLabel(),
    };

    if (Device.osVersion) {
        info.os_version = Device.osVersion;
    }
    if (Device.modelName) {
        info.device_name = Device.modelName;
    }

    return info;
}
